
import { createClient } from '@supabase/supabase-js'

// More verbose logging for debugging environment variables
console.log('Environment variables debugging:');
console.log('Raw VITE_SUPABASE_URL:', import.meta.env.VITE_SUPABASE_URL);
console.log('Raw VITE_SUPABASE_ANON_KEY:', import.meta.env.VITE_SUPABASE_ANON_KEY ? '[EXISTS BUT HIDDEN]' : '[MISSING]');
console.log('typeof VITE_SUPABASE_URL:', typeof import.meta.env.VITE_SUPABASE_URL);
console.log('typeof VITE_SUPABASE_ANON_KEY:', typeof import.meta.env.VITE_SUPABASE_ANON_KEY);

// Try to get values from localStorage first (useful for testing/development)
// Then fall back to environment variables with explicit string conversion and trimming
const supabaseUrl = localStorage.getItem('supabase_url') || 
                   (import.meta.env.VITE_SUPABASE_URL ? String(import.meta.env.VITE_SUPABASE_URL).trim() : '');
                   
const supabaseAnonKey = localStorage.getItem('supabase_key') || 
                       (import.meta.env.VITE_SUPABASE_ANON_KEY ? String(import.meta.env.VITE_SUPABASE_ANON_KEY).trim() : '');

// Log Supabase configuration status for debugging
console.log('Supabase URL source:', localStorage.getItem('supabase_url') ? 'localStorage' : 'env variable');
console.log('Supabase Key source:', localStorage.getItem('supabase_key') ? 'localStorage' : 'env variable');
console.log('Supabase URL status:', supabaseUrl ? 'Provided' : 'Missing');
console.log('Supabase Key status:', supabaseAnonKey ? 'Provided' : 'Missing');

// Helper function to check if Supabase is properly configured
export const isSupabaseConfigured = () => {
  return Boolean(supabaseUrl && supabaseAnonKey);
};

// Create a Supabase client with the configuration
// Using safe fallbacks that will intentionally fail to connect if credentials are missing
export const supabase = createClient(
  supabaseUrl || 'https://example.supabase.co', 
  supabaseAnonKey || 'public-anon-key-placeholder'
);
